
<ngx-spinner name="spinner"
             bdColor="rgba(255,255,255,0.7)"
             color = "#5c85ad"
             [fullScreen]="fullScreen"
             [type]="type"
             [size] = "size">
  <span>{{message}}</span>
</ngx-spinner>
